import { render, staticRenderFns } from "./DebugHelper.vue?vue&type=template&id=0522e38d&"
import script from "./DebugHelper.vue?vue&type=script&lang=js&"
export * from "./DebugHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports